// @ts-check
// Criação de contatos e exclusões de uma conta conectada (doc 03 do mapeamento, seção 5.2; contrato 08 de e-mail
// avançado, seção 3): quando a sincronização cria pessoas, se ignora provedores pessoais e remetentes de grupo.
import { html } from 'htm/preact';
import { CONTACT_AUTO_CREATION_POLICIES } from '../../../../shared/email/email-settings.js';
import { Toggle } from '../../ui/feedback.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ account: import('../../data/calendar.js').ConnectedAccount, canManage: boolean,
 *   onSave: (patch: Partial<import('../../data/calendar.js').ConnectedAccount>) => void }} props
 */
export function ContactCreationOptions({ account, canManage, onSave }) {
  const policy = account.contactAutoCreationPolicy ?? 'NONE';
  return html`<div class="account-card-section" data-testid="contact-creation-options">
    <span class="form-field-label">${t('emailAdvanced.contactCreation.title')}</span>
    <div class="account-visibility-options" role="radiogroup" aria-label=${t('emailAdvanced.contactCreation.title')}>
      ${CONTACT_AUTO_CREATION_POLICIES.map((option) => html`<label key=${option} class="account-visibility-option"
        data-selected=${policy === option ? 'true' : undefined} data-disabled=${canManage ? undefined : 'true'}>
        <input type="radio" name=${`contact-policy-${account.id}`} value=${option} checked=${policy === option} disabled=${!canManage}
          onChange=${() => onSave({ contactAutoCreationPolicy: /** @type {any} */ (option) })} />
        <span class="account-visibility-option-label">${t(`emailAdvanced.contactCreation.policies.${option}.label`)}</span>
        <span class="account-visibility-option-description">${t(`emailAdvanced.contactCreation.policies.${option}.description`)}</span>
      </label>`)}
    </div>
    <div class="account-card-toggle-row">
      <span class="account-toggle-texts">
        <span>${t('emailAdvanced.contactCreation.excludeNonProfessional')}</span>
        <span class="input-hint">${t('emailAdvanced.contactCreation.excludeNonProfessionalHint')}</span>
      </span>
      <${Toggle} value=${account.excludeNonProfessionalEmails ?? false} disabled=${!canManage || policy === 'NONE'}
        ariaLabel=${t('emailAdvanced.contactCreation.excludeNonProfessional')} onChange=${(value) => onSave({ excludeNonProfessionalEmails: value })} />
    </div>
    <div class="account-card-toggle-row">
      <span class="account-toggle-texts">
        <span>${t('emailAdvanced.contactCreation.excludeGroup')}</span>
        <span class="input-hint">${t('emailAdvanced.contactCreation.excludeGroupHint')}</span>
      </span>
      <${Toggle} value=${account.excludeGroupEmails ?? true} disabled=${!canManage}
        ariaLabel=${t('emailAdvanced.contactCreation.excludeGroup')} onChange=${(value) => onSave({ excludeGroupEmails: value })} />
    </div>
  </div>`;
}
